import initLiff from './initLiff'

const liff = {
    initLiff
}

export default liff